import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LibyaService from "../../../Utilies/Utilies/libyaService";
import { notify1 } from "../../../Components/ToastComponent";

let mcpShieldInitialized = false;
let cachedTransactionIdentify = "";
const MCP_SHIELD_SCRIPT_ID = "libya-mcp-shield-script";

export function useLibyaSignupLogic() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [errMsg, setErrMsg] = useState("");

  const [msisdn, setMsisdn] = useState("");
  const [otp, setOtp] = useState("");
  const [isOTP, setIsOTP] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [transactionIdentify, setTransactionIdentify] = useState(
    cachedTransactionIdentify
  );
  const [trafficSource, setTrafficSource] = useState(null);
  const [parameter, setParameter] = useState(null);

  const syncMarketingParamsFromUrl = useCallback(() => {
    const ts =
      searchParams.get("trafficsource") ||
      searchParams.get("trafficSource") ||
      searchParams.get("company");
    const param = searchParams.get("parameter") ?? searchParams.get("key");

    if (ts && ts !== "undefined" && ts !== "null") {
      setTrafficSource(ts);
      try {
        localStorage.setItem("trafficsource", ts);
      } catch (e) {
        /* ignore */
      }
    }
    if (param != null && param !== "" && String(param) !== "undefined") {
      setParameter(String(param));
      try {
        localStorage.setItem("parameter", String(param));
      } catch (e) {
        /* ignore */
      }
    }
  }, [searchParams]);

  useEffect(() => {
    syncMarketingParamsFromUrl();
  }, [syncMarketingParamsFromUrl]);

  useEffect(() => {
    if (!mcpShieldInitialized) {
      mcpShieldInitialized = true;
      checkMCPShield();
    }
  }, []);

  const checkMCPShield = async () => {
    if (document.getElementById(MCP_SHIELD_SCRIPT_ID)) return;

    try {
      const res = await LibyaService.checkMCPShieldLibya();
      if (res?.data?.data) {
        cachedTransactionIdentify = res.data.data.transaction_identify;
        setTransactionIdentify(cachedTransactionIdentify);
        attachScriptInHead(res.data.data.script);
      }
    } catch (e) {
      // optional
    }
  };

  const attachScriptInHead = (script) => {
    if (document.getElementById(MCP_SHIELD_SCRIPT_ID)) return;

    const s = document.createElement("script");
    s.id = MCP_SHIELD_SCRIPT_ID;
    s.type = "text/javascript";
    s.textContent = script;
    document.head.appendChild(s);
    document.dispatchEvent(new Event("DCBProtectRun"));
  };

  const allowOnlyNumbers = (e) => {
    if (e.key.length === 1 && !/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const getOtpErrorMessage = () => {
    const lang = localStorage.getItem("i18nextLng");
    return lang === "ar" ? "رمز التحقق خاطئ" : "Invalid OTP code";
  };

  const getApiErrorMessage = (responseOrError, fallback = "") => {
    const data =
      responseOrError?.data ??
      responseOrError?.response?.data ??
      responseOrError;

    return (
      data?.message ||
      data?.data?.message ||
      data?.error ||
      fallback
    );
  };

  const showError = (message) => {
    if (!message) return;
    setErrMsg(message);
    notify1(message);
  };

  const validPrefixes = ["91", "92", "93", "94", "95", "96", "97", "98", "99"];

  const getLocalNumberPart = (value) => {
    if (value.startsWith("218")) return value.slice(3);
    if (value.startsWith("0")) return value.slice(1);
    return value;
  };

  const hasValidLibyaPrefix = (value) => {
    const numberPart = getLocalNumberPart(value);
    if (numberPart.length < 2) return true;
    return validPrefixes.some((p) => numberPart.startsWith(p));
  };

  const formatMsisdnForApi = (value) => {
    let local = getLocalNumberPart(value);
    if (local.startsWith("0")) {
      local = local.slice(1);
    }
    return local;
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!isValidMsisdn) return;

    const formattedMsisdn = formatMsisdnForApi(msisdn);

    setIsLoading(true);
    try {
      const res = await LibyaService.sendPinLibya(
        formattedMsisdn,
        transactionIdentify
      );
      setIsLoading(false);

      if (res.data.success) {
        localStorage.setItem("msisdn", formattedMsisdn);
        setIsOTP(true);
        setErrMsg("");
      } else {
        showError(getApiErrorMessage(res.data, "Something went wrong"));
      }
    } catch (err) {
      setIsLoading(false);
      showError(getApiErrorMessage(err, "Something went wrong"));
    }
  };

  const onVerifyOtp = async (e) => {
    e.preventDefault();

    if (otp.length !== 4) return;

    const formattedMsisdn =
      localStorage.getItem("msisdn") || formatMsisdnForApi(msisdn);

    setIsLoading(true);
    try {
      const res = await LibyaService.verifyLibya(
        formattedMsisdn,
        otp,
        trafficSource,
        parameter
      );

      setIsLoading(false);
      if (res.data.token) {
        if(res.data?.code){
        localStorage.setItem("code", res.data.code);

        }
        localStorage.setItem("token", res.data.token);
        localStorage.setItem(
          "userImage",
          JSON.stringify(res.data.user?.avatar)
        );
        setErrMsg("");
        setTimeout(() => {
          navigate("/success", { replace: true });
        }, 2500);
      } else {
        showError(getApiErrorMessage(res.data, getOtpErrorMessage()));
      }
    } catch (err) {
      setIsLoading(false);
      showError(getApiErrorMessage(err, getOtpErrorMessage()));
    }
  };


  const handleMsisdnChange = (e) => {
    const value = e.target.value;

    if (!/^\d*$/.test(value)) return;

    const isWithCountryCode = value.startsWith("218");
    const startsWithZero = value.startsWith("0");

    if (isWithCountryCode && value.length > 12) return;
    if (startsWithZero && value.length > 10) return;
    if (!isWithCountryCode && !startsWithZero && value.length > 9) return;

    if (!hasValidLibyaPrefix(value)) return;

    setMsisdn(value);
  };

  const isValidMsisdn = msisdn.startsWith("218")
    ? msisdn.length === 12
    : msisdn.startsWith("0")
      ? msisdn.length === 10
      : msisdn.length === 9;

  return {
    errMsg,
    setErrMsg,
    msisdn,
    setMsisdn,
    otp,
    setOtp,
    isOTP,
    setIsOTP,
    isLoading,
    isValidMsisdn,
    onSubmit,
    onVerifyOtp,
    allowOnlyNumbers,
    handleMsisdnChange,
  };
}
